import moment from "moment";

const EXPIRATION_MINUTES = 7;

export function setStorage(key, value, hasCache = false, minutes = EXPIRATION_MINUTES) {
  const payload = hasCache
    ? { data: value, expiresAt: moment().add(minutes, "minutes").toISOString() }
    : { data: value };

  try {
    localStorage.setItem(key, JSON.stringify(payload));
  } catch (e) {
    console.error("Erro ao salvar no localStorage:", e);
  }
}

export function getStorage(key, hasCache = false) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    const { data, expiresAt } = parsed || {};

    if (hasCache && expiresAt && moment.utc().isAfter(moment(expiresAt))) {
      localStorage.removeItem(key);
      return null;
    }

    return data ?? null;
  } catch (e) {
    console.error("Erro ao ler do localStorage:", e);
    removeStorage(key);
    return null;
  }
}

export function removeStorage(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.error("Erro ao remover do localStorage:", e);
  }
}